import PropTypes from 'prop-types';
import React from 'react';
import {formatPhoneNumber} from 'src/shared/utils/formatPhoneNumber';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import StatusCheck from 'src/svgs/status/check.svg';
import {header} from '../header.module.scss';
import {
  icon,
} from './style.module.scss';

export const CallConfirmedView = ({
  appointment,
  email,
  onCancelCallback,
  onComplete,
  phone,
}) => {
  return (
    <div>
      <header className={header}>
        <StatusCheck className={icon} />
        {
          appointment?.interaction?.type !== 'IMMEDIATE_CALLBACK'
          && <h1>Your callback has been scheduled for {appointment.time}.</h1>
        }
        {
          appointment?.interaction?.type === 'IMMEDIATE_CALLBACK'
          && <h1>Your callback has been scheduled for the next available time slot.</h1>
        }
        <p>
          We&apos;ll call you at {formatPhoneNumber(phone)}.
          {
            appointment?.interaction?.type !== 'IMMEDIATE_CALLBACK'
            && <> We&apos;ve sent your call details to <span data-notranslate="true">{email}</span>.</>
          }
        </p>
      </header>
      <div className={buttonGroup}>
        <button className={`${button} ${primary}`} onClick={onComplete}>Thanks, I&apos;m Done</button>
        <button className={button} onClick={onCancelCallback}>Cancel Callback</button>
      </div>
    </div>
  );
};

CallConfirmedView.propTypes = {
  appointment: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  onCancelCallback: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
};
